import { render, staticRenderFns } from "./types.vue?vue&type=template&id=24d0686f&scoped=true"
import script from "./types.vue?vue&type=script&setup=true&lang=js"
export * from "./types.vue?vue&type=script&setup=true&lang=js"
import style0 from "./types.vue?vue&type=style&index=0&id=24d0686f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d0686f",
  null
  
)

export default component.exports